// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { WidgetChartTypeEnum, WidgetRadarOutput } from 'thehive-sdk';
import NewWidgetDrawer from '@Organisms/Dashboard/WidgetManage/NewWidgetDrawer';
import { RadarForm, RadarValues } from '@Organisms/Dashboard/WidgetManage/Radar/RadarForm';

export const getNewRadarWidget = (radar: RadarValues): WidgetRadarOutput => {
    const { title, entity, category, stacked = false, filters = [], periodDateField } = radar;

    return {
        type: WidgetChartTypeEnum.radar,
        options: {
            title,
            entity,
            field: category,
            query: {},
            names: {},
            stacked,
            filters,
            periodDateField,
        },
        id: '',
    };
};

const NewRadarDrawer = (): ReactElement => (
    <NewWidgetDrawer
        getNewWidget={(values) => getNewRadarWidget(values as RadarValues)}
        WidgetForm={RadarForm}
        widgetType="radar"
    />
);

export default NewRadarDrawer;
